import { Component, OnInit, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from 'src/app/global/global.component';
import { FilterSettingsModel, GridComponent, DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { EmployeePayrollService } from './employee-payroll.service';
import { PayrollInformationBO, WorkHistoryBO, GetListBaseHistoryBO, WhereCondition, AccountNumberShowBO } from './employee-payroll.model';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from '../../../date.service';
import { IMyDpOptions } from "mydatepicker";
import { EmployeeworkHistoryService } from './employee-payrolllhistory.service';
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { functionpermission } from '../employee.model';

@Component({
  selector: 'app-employee-payroll',
  templateUrl: './employee-payroll.component.html',
  styleUrls: ['./employee-payroll.component.scss']
})

export class EmployeePayrollComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;
  @Input() EmployeeId: string;

  employeePayrollinformationBO: PayrollInformationBO = new PayrollInformationBO();
  getworkhistory: GetListBaseHistoryBO = new GetListBaseHistoryBO();
  employeeworkhistoryBO: WorkHistoryBO = new WorkHistoryBO();
  conditionData: WhereCondition = new WhereCondition();
  private onDestroy$: Subject<void> = new Subject<void>();
  fp: functionpermission = new functionpermission()

  MaritialStatus: [{ Key: string, Value: string }];
  PayCHeckType: [{ Key: string, Value: string }];

  PayrollForm: FormGroup;
  public data: Observable<DataStateChangeEventArgs>;

  conditionlist: WhereCondition[] = [];
  arraycol: any = [];
  public formatOptions: object
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: object;
  isSaveorUpdateBoolean:boolean=false;
  hireDateFilter: any;
  inactiveDateFilter: any;
  termDateFilter: any;

  filterOptions: FilterSettingsModel;
  workhistoryForm: FormGroup;
  // ........................................................................................................................
  today = new Date();
  showPassAccountRouting: FormGroup;
  showText:any;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate() + 1,
    },
    showClearDateBtn: true,
    editableDateField: true,
  };

  public myDatePickerOptionsDOB: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    disableSince: {
      year: this.today.getFullYear(),
      month: this.today.getMonth() + 1,
      day: this.today.getDate() + 1,
    },
    showClearDateBtn: false,
    editableDateField: true,
  };
  // .............................................................................................................................

  constructor(private formBuilder: FormBuilder, public employeePayrollService: EmployeePayrollService,
    public toasterservice: ToastrService, public dateservice: DateService, public global: GlobalComponent,
    public employeeworkHistoryService: EmployeeworkHistoryService, public datepipe: DatePipe,
    private cdr: ChangeDetectorRef) {
    this.workhistoryForm = this.formBuilder.group({
      hireDate: [' '],
      inactiveDate: [' '],
      termDate: [' '],
    });
    this.showPassAccountRouting = new FormGroup({
      Password: new FormControl('', [Validators.required])
    });

    this.data = employeeworkHistoryService

  }

  ngOnInit(): void {
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.getpaycheck();
    this.getMaritialStatus();
    this.GetClientDropdown();
    this.getWorkHistory();
    this.GetPayRollDetail();
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.getpermission()

  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "employee");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.employeePayrollService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

        if (data != null) {
          this.fp = data;

        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'HireDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);
          this.employeeworkhistoryBO.hireDate = element;
        }

      }
      if (name == 'InactiveDate') {
        let val = this.dateservice.inputFeildchangeReturnall(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.employeeworkhistoryBO.inactiveDate = element;

        }

      }
      if (name == 'TermDate') {

        let val = this.dateservice.inputFeildchangeReturnall(event);

        if (val != undefined) {

          let element = this.dateservice.inputFeildchangeReturnall(event);

          this.employeeworkhistoryBO.termDate = element;

        }

      }

    }

    if (type == "datechanged") {
      if (name == 'HireDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.employeeworkhistoryBO.hireDate = element;
        }
      }

      if (name == 'InactiveDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.employeeworkhistoryBO.inactiveDate = element;
        }
      }
      if (name == 'TermDate') {

        let val = this.dateservice.Datechange(event);

        if (val != undefined) {

          let element = this.dateservice.Datechange(event);

          this.employeeworkhistoryBO.termDate = element;
        }
      }
    }
  }
  // .................................................SAVE EMPLOYEE PAYROLL.........................................................................

  SaveEmployeePayroll() {
    this.isSaveorUpdateBoolean=true;
    this.employeePayrollinformationBO.employeeId = this.EmployeeId

    if (this.employeePayrollinformationBO.id == '00000000-0000-0000-0000-000000000000' ||
      this.employeePayrollinformationBO.id == undefined || this.employeePayrollinformationBO.id == null) {

      this.employeePayrollinformationBO.id == '00000000-0000-0000-0000-000000000000'
      this.employeePayrollService.saveemployeepayroll(this.employeePayrollinformationBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.employeePayrollinformationBO.id = data;
        this.isSaveorUpdateBoolean=false;
        this.toasterservice.success("Employee Payroll Infromation saved successfully", "Employee Payroll saved");
        this.GetPayRollDetail();
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterservice.error(err, "Error");
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
      );
    }

    else {
      this.employeePayrollService.saveemployeepayroll(this.employeePayrollinformationBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.employeePayrollinformationBO.id = data;
        this.isSaveorUpdateBoolean=false;
        this.toasterservice.success('Employee Payroll Infromation updated successfully', 'Payroll updated');
        this.GetPayRollDetail();
        setTimeout(() => {
          this.toasterservice.clear();
        }, 8000);
      },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterservice.error(err, "Error");
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }

      );
    }

  }
  // ..........................................................................................................................

  dateCreateupdate(type: string) {
    if (type == 'new') {
      this.ModelType = 'new';
      this.employeeworkhistoryBO = new WorkHistoryBO();
      this.workhistoryForm.reset();
    }
    else {
      this.ModelType = 'edit';
    }

  }

  edittype(data) {
    this.employeeworkhistoryBO = JSON.parse(JSON.stringify(data));

    this.employeeworkhistoryBO.hireDate = this.datepipe.transform
      (this.employeeworkhistoryBO.hireDate, "MM/dd/yyyy")
    this.employeeworkhistoryBO.inactiveDate = this.datepipe.transform
      (this.employeeworkhistoryBO.inactiveDate, "MM/dd/yyyy")
    this.employeeworkhistoryBO.termDate = this.datepipe.transform
      (this.employeeworkhistoryBO.termDate, "MM/dd/yyyy")
  }

  // ..................................SAVE EmployeeWorkhistory..........................................................................

  saveemployeeworkhistory(type: string) {
    this.isSaveorUpdateBoolean=true;
    let saveData: WorkHistoryBO = JSON.parse(
      JSON.stringify(this.employeeworkhistoryBO)
    );
    saveData.employeeId = this.EmployeeId,

      saveData.hireDate = (this.employeeworkhistoryBO.hireDate != null &&
        this.employeeworkhistoryBO.hireDate != "" && this.employeeworkhistoryBO.hireDate != undefined) ? this.global.getDateTimeString(this.employeeworkhistoryBO.hireDate) : null;

    saveData.inactiveDate = (this.employeeworkhistoryBO.inactiveDate != null &&
      this.employeeworkhistoryBO.inactiveDate != "" && this.employeeworkhistoryBO.inactiveDate != undefined) ? this.global.getDateTimeString(this.employeeworkhistoryBO.inactiveDate) : null;

    saveData.termDate = (this.employeeworkhistoryBO.termDate != null &&
      this.employeeworkhistoryBO.termDate != "" && this.employeeworkhistoryBO.termDate != undefined) ? this.global.getDateTimeString(this.employeeworkhistoryBO.termDate) : null;
    this.employeePayrollService.saveemployeeworkhistory(saveData)
      .pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data) {
          this.isSaveorUpdateBoolean=false;
          if (saveData.id == "00000000-0000-0000-0000-000000000000") {
            this.toasterservice.success(
              "Key Status and Dates Saved Successfully",
              'Key Status and Dates Saved'
            );
            document.getElementById("openModal1").click();
            this.getWorkHistory();
            setTimeout(() => {
              this.toasterservice.clear();
            }, 8000);
          }
          else {
            this.toasterservice.success(
              "Key Status and Dates Updated successfully",
              "Key Status and Dates Updated",
            );
          }
          document.getElementById("openModal1").click();
          this.getWorkHistory();
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);

        }
      },
        (err: any) => {
          this.isSaveorUpdateBoolean=false;
          this.toasterservice.error(err.error, "Error");
          setTimeout(() => {
            this.toasterservice.clear();
          }, 8000);
        }
      );
  }

  getWorkHistory() {
    this.getworkhistory.employeeId = this.EmployeeId
    this.employeeworkHistoryService.executeworkhistory(this.getworkhistory);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      count = count + 1;
    })
  }

  //......................................GetClientDropdown........................................
  ClientDropdown: any;
  hiredate: string;
  inactivedate: string;
  termdate: string;

  ModelType: any;

  GetClientDropdown() {
    this.employeePayrollService.GetClientDropdown().pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientDropdown = data;
    })
  }

  ///////////////////////////////////////////pay check Type////////////////////////////////////////////////////////////

  getpaycheck() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("listCode", "PAYCHECKTYPE");
    this.employeePayrollService.getPayCheckType(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.PayCHeckType = data;
    })
  }
  //////////////////////////////////////////////get Maritial Status ////////////////////////////////////////////////////
  getMaritialStatus() {
    let params = new URLSearchParams();
    params.append("listCode", "MARITALSTATUS");
    let url = "api/LOV/getLovDropDown?"
    this.employeePayrollService.getMaritialStatus(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: [{ Key: string, Value: string }]) => {
      this.MaritialStatus = data;
    })
  }

  public onActionComplete(args) {
    this.getworkhistory.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.getworkhistory.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }

  }

  type: string = "";
  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.getworkhistory.orderColumn = state.sorted[0].name;
        this.getworkhistory.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.getworkhistory.field = state.action.currentFilterObject.field;
      this.getworkhistory.matchCase = state.action.currentFilterObject.matchCase;
      this.getworkhistory.operator = state.action.currentFilterObject.operator;
      this.getworkhistory.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.getworkhistory.field = "hireDate";
        this.getworkhistory.matchCase = false;
        this.getworkhistory.operator = "startswith";
        this.getworkhistory.value = "";
      }
    }
    this.getWorkHistory();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].WorkHistory.Pagesize != state.take) {
          this.arraycol[0].WorkHistory.Pagesize = state.take
        }

      }
    }
  }

  GetPayRollDetail() {
    let payrollparams = new URLSearchParams();
    payrollparams.append("empId", this.EmployeeId)
    this.employeePayrollService.getpayrollInfrom(payrollparams).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      if (data) {
        this.employeePayrollinformationBO = data
      }
    });

  }

  clearkey() {
    this.employeeworkhistoryBO = new WorkHistoryBO()
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  passerror:boolean;
  admin_Password:any;
  filedname:any;
  passvalid(event) {
    let str = event.target.value;
    if (str.match(/[a-z]/g) && str.match(
      /[A-Z]/g) && str.match(
        /[0-9]/g) && str.match(
          /[^a-zA-Z\d]/g) && str.length >= 8) {
      this.passerror = false;
    }
    else {
      this.passerror = true;
    }
  }
  AccountNumberShowBO:AccountNumberShowBO = new AccountNumberShowBO()
  setfieldName(val) {
    this.admin_Password = null;
    const passControl = this.showPassAccountRouting.get('Password');
    if (passControl) {
      passControl.markAsPristine();
      passControl.markAsUntouched(); 
    }
    this.filedname=val;
    this.showedString='';
    this.AccountNumberShowBO=new AccountNumberShowBO();
  }
  showedString:string;
  showRoutingAcct() {
    this.AccountNumberShowBO.employeeId=this.EmployeeId;
    this.AccountNumberShowBO.fieldname=this.filedname;
    this.AccountNumberShowBO.admin_Password=this.admin_Password;
    this.AccountNumberShowBO.tableType="payroll";
    this.employeePayrollService.ShowEmployeePayrolldata(this.AccountNumberShowBO).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
   
     
      this.passerror = false;
     if(data) {
      this.showedString=data;
     }
      // this.toasterservice.success(
      //   'EvvTimesheet deleted successfully!'
      // ), 8000;     
    //  document.getElementById("openShowPass").click();
     
     
    },
      (err: HttpErrorResponse) => {
        this.passerror = false;
        this.toasterservice.error(
          err.error
        ), 4000;
       
      }
    );
  }
}
















